<template>
	<div class="head">
		<Button class="menu-btn" @click="toggleMenu()" :class="{active: visibleMobileMenu}">
			<svg-ico name="menu" width="20" height="16"/>
		</Button>

		<!-- Logo -->
		<div class="head__logo">
			<router-link :to="{name: 'Home'}" :aria-current="null" :active-class="''" :exact-active-class="''">
				<SvgIco name="logo_black" class="logo" v-if="0"/>
				<img :src="logoUrl" alt="" v-if="this.user" style="height: 54px">
			</router-link>

			<div class="tagline"></div>
		</div>
		<!-- End Logo -->

		<component
			class="head__navi"
			:class="{'big-margin': showTopNotification}"
			:is="screen > 900 ? 'div' : 'Curtain'"
      position="top"
			v-model="visibleMobileMenu"
		>
			<router-link to="/" class="navi__link" @click.native="visibleMobileMenu = false">
				<SvgIco name="courses" class="navi__ico navi__courses"/>
				<b>Available<br> courses</b>
			</router-link>
			<router-link
				:to="{name: 'Course', params: {courseId: user.lastLesson.courseId, chapterId: user.lastLesson.chapterId ? user.lastLesson.chapterId : 0 , moduleId: user.lastLesson.moduleId, type: 'lesson', typeId: user.lastLesson.id}}"
				class="navi__link"
				v-if="user && user.lastLesson"
				@click.native="visibleMobileMenu = false"
			>
				<SvgIco name="resume" class="navi__ico navi__resume"/>
				<b>Continue<br> training</b>
			</router-link>
		</component>

		<component
			class="head__auth"
			:class="{'big-margin': showTopNotification}"
			:is="screen > 900 ? 'div' : 'Curtain'"
      position="top"
			v-model="visibleMobileAuthMenu"
		>
			<Loader size="small" v-if="!user"/>
			<Button class="head__user" size="self" v-else @click.capture="toggleAuthMenu()">
				<div class="head__user-name">{{ user.email }}</div>
				<SvgIco name="arr-v" class="arrow head__user-arr"/>
			</Button>

			<!-- User links -->
			<component :is="screen > 900 ? 'Dropdown' : 'div'" v-if="user" v-model="visibleAuthMenu" class="auth__menu menu">
				<router-link :to="{ name: 'Profile'}" class="menu__item" @click.native="toggleAuthMenu()">Profile</router-link>
				<button class="menu__item" @click="logout()">Log out</button>
			</component>
			<!-- End User links -->
		</component>

		<Button class="user-btn" @click="toggleUserMenu()" :class="{active: visibleMobileAuthMenu}">
			<svg-ico name="m-user" width="24" height="24"/>
		</Button>
	</div>
</template>

<script>
import config from '@shared/config'
import Button from '@shared/components/base/Button.vue'
import SvgIco from '@shared/components/base/SvgIco.vue'
import Loader from '@shared/components/base/Loader.vue'
import Dropdown from '@shared/components/base/Dropdown.vue'
import Curtain from '@shared/components/base/Curtain.vue'
import {useGeneralStore} from "@shared/stores/general.js"
import {useUserStore} from "@shared/stores/user.js"
import {useAuthStore} from "@shared/stores/auth.js"


export default {
	components: {
		Button,
		SvgIco,
		Loader,
		Dropdown,
		Curtain
	},

	data: () => ({
		visibleAuthMenu: false,
		visibleMobileMenu: false,
		visibleMobileAuthMenu: false
	}),

	computed: {
    user() {
      return useUserStore().info
    },
    screen() {
      return useGeneralStore().screen
    },
    showTopNotification() {
      return useGeneralStore().showTopNotification
    },
		logoUrl() {
			return config.apiHost + '/images/' + this.user.legalEntity.logo
		}
	},

	methods: {
		logout() {
			this.visibleAuthMenu = false
      useAuthStore().logoutAction()
		},

		toggleAuthMenu() {
			if (this.screen > 900) this.visibleAuthMenu = !this.visibleAuthMenu
      else this.visibleMobileAuthMenu = !this.visibleMobileAuthMenu
		},

		toggleMenu() {
			this.visibleMobileMenu = !this.visibleMobileMenu
			this.visibleMobileAuthMenu = false
		},

		toggleUserMenu() {
			this.visibleMobileAuthMenu = !this.visibleMobileAuthMenu
			this.visibleMobileMenu = false
		},
		openOnlineConsultant() {
			window.jivo_api.open({ start: 'chat' })
		}
	}
}
</script>

<style>
	.head {position:relative;z-index:3;display:flex;align-items:center;justify-content:space-between;margin:10px 0 20px;padding:0 14px;height:84px;}
	.head::before {content:'';z-index:-1;position:absolute;top:0;right:0;bottom:0;left:0;background:#fff;border-radius:var(--radius-xl);box-shadow:0 15px 10px -10px rgba(50,50,62,.08);}
	.head__logo {display:flex;align-items:center;}

	.logo {width:167px;height:54px;}
	.tagline {margin-left:12px;color:var(--dark2);}

	.menu-btn,
	.user-btn {display:none;padding:8px 10px;height:40px;color:var(--light4);}
	.menu-btn.active,
	.user-btn.active {color:var(--violet);background:var(--light1);}
	.menu-btn svg,
	.user-btn svg {fill:currentColor;}

	/* Navi */
	.head__navi {display:flex;align-items:center;margin:0 10px;}
	.navi__link {padding:3px 6px;line-height:1.2;color:var(--dark2);text-align:center;text-decoration:none;transition:color .2s, background .4s;border-radius:var(--radius-l);}
	.navi__link.ex_active {cursor:default;background:var(--light0);}
	.navi__link.ex_active .navi__ico {fill:var(--light4);}
	.navi__link:not(.ex_active):hover {color:var(--violet2);}
	.navi__link:not(.ex_active):hover .navi__ico {fill:var(--violet);}
	.navi__link + .navi__link {margin-left:25px;}
	.navi__ico {margin:0 auto;height:32px;fill:var(--light3);transition:fill .2s;}
	.navi__courses {width:32px;}
	.navi__resume {width:32px;}
	.navi__support {width:38px;}

	/* Auth */
	.head__auth {display:flex;}
	.head__user {margin-left:auto;}
	.head__user-name {max-width:250px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
	svg.head__user-arr {flex-shrink:0;margin-left:6px;fill:var(--light4);}
	.auth__menu {top:55px;right:0;overflow:hidden;width:180px;box-shadow:0 3px 8px rgba(0,0,0,.2);border-radius:var(--radius-l);}

	@media (max-width:1000px) {
		.head {padding:0 10px;height:76px;}
		.logo {width:166px;height:48px;}
		.tagline {margin-left:8px;font-size:.91rem;}
		.navi__link {font-size:.94rem;}
		.navi__link + .navi__link {margin-left:10px;}
		.navi__courses {width:28px;}
		.navi__resume {width:28px;}
		.navi__support {width:32px;}
		.head__user-name {font-size:.94rem;}
	}

	@media (max-width:900px) {
		.head {margin:0 -10px 10px;padding:5px 6px;height:56px;}
		.head::before {border-radius:0;box-shadow:0 5px 10px rgba(50,50,62,.08);}
		.menu-btn,
		.user-btn {display:block;}
		.head__logo {margin:0 auto;}

		/* Navi */
		.head__navi, .head__auth {top:54px;margin:0;z-index:-2;}
		.head__navi.big-margin, .head__auth.big-margin {top:123px;}
		.navi__link {display:flex;align-items:center;padding:6px 10px;border-top:1px solid var(--light2);border-radius:0;}
		.navi__link:last-child {border-bottom:1px solid var(--light2);}
		.navi__link + .navi__link {margin:0;}
		.navi__link br {display:none;}
		.navi__ico {margin:0 8px 0 0;}

		/* Auth */
		.head__user {margin:0;width:100%;}
		.head__user-arr {display:none;}
		.head__user-name {max-width:none;font-size:1rem;}
		.auth__menu {margin:15px 0;width:100%;border-top:1px solid var(--light2);border-bottom:1px solid var(--light2);border-radius:0;box-shadow:none;}
		.auth__menu .menu__item {padding:10px 8px;}
	}

	@media (max-width:420px) {
		.tagline {display:none;}
	}
</style>
